import axios from 'axios';
import apiroutes from '@/API/ApiRoutes';


const state = {};

const getters = {};

const actions = {

  LogIn({commit}, payload) {

    return new Promise((resolve, reject) => {
      axios.post(apiroutes.routes.login, payload, {headers: apiroutes.headers().basic})
        .then((response) => {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  imageUpload({commit}, payload) {

    console.log(payload.picture);
    return new Promise((resolve, reject) => {
      console.log(apiroutes.headers().authheader)
      axios.post(apiroutes.routes.register +'/'+ payload.id +'/profile_picture_upload_web', payload.picture, {headers: apiroutes.headers().imageHeader})
        .then((response) => {
          if(response.status !== 401){
          resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  RegisterNewUser({commit},payload){
    return new Promise((resolve, reject) => {
      axios.post(apiroutes.routes.register,payload,{headers : apiroutes.headers().basic})
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
      });
    });

  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
